import { useGetSurveyQuery } from "@api/survey";
import { useRequiredParams } from "@utils/params";
import { JSX } from "react";
import { Navigate, useLocation } from "react-router";

export const RequireSurvey = ({ children }: { children: JSX.Element }) => {
  const location = useLocation();
  const { courseId } = useRequiredParams(["courseId"]);

  const { data: survey } = useGetSurveyQuery(courseId);

  const isOnSurveyPage = location.pathname.endsWith("/survey");
  if (isOnSurveyPage) {
    return children;
  }

  if (survey) {
    return <Navigate to={`/course/${courseId}/survey`} replace />;
  }

  return children;
};
